define.alias("shared/helpers/format-number-with-suffix", "settings/helpers/format-number-with-suffix");